<template>
    <base-side-bar>
        <div class="flex flex-col items-center justify-center w-full mx-10">
            <h2
                class="w-4/5 mb-4 ml-10 font-extrabold leading-9 text-center text-blue-600 sm:text-xl sm:leading-10"
            >
                Votre Projet
            </h2>
            <base-steps :steps="steppers" :require="true" />
            <router-view v-on:showNotification="showNotification" />
        </div>
    </base-side-bar>
</template>

<script>
import { mapState } from "vuex";
export default {
    components: {},
    data() {
        return {};
    },
    created() {
        this.$store.dispatch("forms/showSection", "Vous et votre projet");
        this.$store.dispatch("forms/stepFocus", "Votre projet");
    },
    computed: {
        ...mapState("forms", {
            steppers: state => state.votreProjectSteepers
        })
    },
    methods: {
        showNotification(notification) {
            this.$emit("showNotification", notification);
        }
    }
};
</script>

<style></style>
